import React from 'react';
import classnames from 'classnames';
import { createUseStyles, Label } from '@Sage/hoi-poi-ui';
import PropTypes from 'prop-types';

import styles from './styles';
const useStyles = createUseStyles(styles, 'MultiComponent');

function MultiComponent({ isRequired = false, label, hint, uiGrid, children, ...props }) {
    const classes = useStyles();
    const gridClassName = classnames({
        [classes[uiGrid]]: uiGrid,
    });
    return (
        <div className={classes.root}>
            {label && (
                <Label className={classes.label} isRequired={isRequired} hint={hint}>
                    {label}
                </Label>
            )}
            <div className={gridClassName}>{children}</div>
        </div>
    );
}

MultiComponent.propTypes = {
    uiGrid: PropTypes.string,
};

export default React.memo(MultiComponent);
